var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-pagination-nav", {
    staticClass: "my-2",
    attrs: {
      "number-of-pages": _vm.numberOfPages,
      "link-gen": _vm.linkGen,
      pills: "",
      size: "md",
      align: "center",
      "first-number": "",
      "last-number": "",
      limit: "15"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }